import { Routes } from '@angular/router';
import { authGuard, canMatchGuard } from './core/guards/auth.guards';
import { authorizationGuard } from './core/guards/authorization.guards';
import { PERMISSIONS } from './core/constants/permissions.constants';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadComponent: () => import('./public/auth/auth.component').then((m) => m.AuthComponent),
  },
  {
    path: 'not-authorized',
    loadComponent: () =>
      import('./public/no-autorizado/no-autorizado.component').then((m) => m.NoAutorizadoComponent),
  },
  {
    path: 'private',
    loadComponent: () => import('./pages/main/main.component').then((m) => m.MainComponent),
    canActivate: [authGuard],
    canMatch: [canMatchGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/home-procesos-seleccion/home-procesos-seleccion.component').then(
            (m) => m.HomeProcesosSeleccionComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.HOME },
      },
      {
        path: 'procesos-seleccion',
        loadComponent: () =>
          import('./pages/procesos-seleccion/procesos-seleccion.component').then(
            (m) => m.ProcesosSeleccionComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.GRILLA_PROCESOS_SELECCION_VER },
      },
      {
        path: 'gestionar-proceso-seleccion',
        loadComponent: () =>
          import('./pages/crear-proceso-seleccion/crear-proceso-seleccion.component').then(
            (m) => m.CrearProcesoSeleccionComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.FORMULARIO_SOLICITUD_SELECCION_CREAR },
      },
      {
        path: 'detalle-proceso-seleccion',
        loadComponent: () =>
          import('./pages/detalle-proceso-seleccion/detalle-proceso-seleccion.component').then(
            (m) => m.DetalleProcesoSeleccionComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.GRILLA_PROCESOS_SELECCION_VER },
      },
      {
        path: 'detalle-proceso-seleccion/formulario-solicitud-ingreso-colaborador',
        loadComponent: () =>
          import('./pages/formulario-solicitud-ingreso-colaborador/formulario-solicitud-ingreso-colaborador.component').then(
            (m) => m.FormularioSolicitudIngresoColaboradorComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.FORMULARIO_SOLICITUD_INGRESO_CREAR },
      },
      {
        path: 'solicitudes-ingreso',
        loadComponent: () =>
          import('./pages/solicitudes-ingreso/solicitudes-ingreso.component').then(
            (m) => m.SolicitudesIngresoComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.GRILLA_PROCESOS_INGRESO_VER },
      },
      {
        path: 'detalle-solicitud-ingreso-colaborador/:proceso/:sc/:src',
        loadComponent: () =>
          import('./pages/detalle-solicitud-ingreso-colaborador/detalle-solicitud-ingreso-colaborador.component').then(
            (m) => m.DetalleSolicitudIngresoColaboradorComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.GRILLA_PROCESOS_INGRESO_VER },
      },
      {
        path: 'formulario-ingreso-colaborador/:proceso/:sc/:src/:formId',
        loadComponent: () =>
          import('./pages/formularioIngresoColaborador/formularioIngresoColaborador.component').then(
            (m) => m.FormularioIngresoColaborador,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.FORMULARIO_SOLICITUD_INGRESO_VER },
      },
      {
        path: 'mant-usuarios',
        loadComponent: () =>
          import('./pages/mant-usuarios/mant-usuarios.component').then(
            (m) => m.MantUsuariosComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.USUARIOS_VER },
      },
      {
        path: 'gestionar-usuario/:id',
        loadComponent: () =>
          import('./pages/gestionar-usuario/gestionar-usuario.component').then(
            (m) => m.GestionarUsuarioComponent,
          ),
        canActivate: [authorizationGuard],
        data: { permissions: [PERMISSIONS.USUARIOS_CREAR, PERMISSIONS.USUARIOS_EDITAR] },
      },
      {
        path: 'ver-usuario/:id',
        loadComponent: () =>
          import('./pages/ver-usuario/ver-usuario.component').then((m) => m.VerUsuarioComponent),
        canActivate: [authorizationGuard],
        data: { permission: PERMISSIONS.USUARIOS_VER },
      },
    ],
  },
  {
    path: 'portal-ingreso-candidatos',
    loadChildren: () =>
      import('./pages/portal-ingreso-candidatos/portal-ingreso-candidatos.module').then(
        (m) => m.PortalIngresoCandidatosModule,
      ),
  },
  {
    path: 'obtener-documento/:key',
    loadComponent: () =>
      import('./pages/obtener-documento/obtener-documento.component').then(
        (m) => m.ObtenerDocumentoComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'not-authorized',
  },
];
